import { useAppBridge } from '@shopify/app-bridge-react';
import {
    LegacyCard,
    Button,
    ButtonGroup,
    FormLayout,
    TextField,
} from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from '@shopify/app-bridge/actions';
import Api from '../../helpers/api';
import formatErrors from '../../helpers/format_errors';

export default function ApproveSection ({ customer, setCustomer }) {
    const [accountNumber, setAccountNumber] = useState(customer.account_number);
    const [showApprove, setShowApprove] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const app = useAppBridge();

    useEffect(() => {
        setLoading(false);
    }, [customer]);

    const handleErrorResponse = error => {
        if ( error?.response?.status == 422 ) {
            setErrors(formatErrors(error.response.data));
        } else {
            throw error;
        }
    }

    const approve = useCallback((accountNumber) => {
        setLoading(true);

        Api.changeCustomerStatus(customer.id, 'approved', accountNumber)
            .then(response => {
                setCustomer(response.data.data);

                Toast.create(app, { message: 'Company was approved', duration: 3000 })
                    .dispatch(Toast.Action.SHOW);
            })
            .catch(handleErrorResponse)
            .finally(() => setLoading(false))

    }, [customer]);

    const reject = useCallback(async () => {
        setLoading(true);

        Api.changeCustomerStatus(customer.id, 'rejected')
            .then(() => {
                Toast.create(app, { message: 'Company was rejected', duration: 3000 })
                    .dispatch(Toast.Action.SHOW);

                history.goBack()
            })
            .catch(handleErrorResponse)
            .finally(() => setLoading(false))
    }, [customer]);

    const toggleApprove = () => {
        approve(accountNumber);
    };

    const submitLabel = showApprove
        ? 'Submit'
        : 'Approve';

    return (
        <LegacyCard sectioned>
            <ButtonGroup>
                <Button  onClick={reject} disabled={loading} variant="primary" tone="critical">Reject</Button>
                <Button  onClick={toggleApprove} disabled={loading} variant="primary">{submitLabel}</Button>
            </ButtonGroup>
        </LegacyCard>
    );
}
